module.exports = __webpack_public_path__ + "img/wt.26960a64.png";